import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useApiQuery } from '../hooks/useApiQuery';
import { list as listCategories } from '../apis/categories';
import { initialize as initAuth } from '../store/reducers/authReducer';
import { initialize as initCart } from '../store/reducers/cartReducer';
import { initialize as initUi } from '../store/reducers/uiReducer';

export const useAppInitializer = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [categoriesOptions] = useState({ page: 1, size: 7 });
    const categories = useApiQuery(listCategories, categoriesOptions);
    const auth = useSelector((state) => state.auth);
    const cart = useSelector((state) => state.cart);
    const ui = useSelector((state) => state.ui);

    const isInitialized =
        categories.isLoading && auth.isInitialized && cart.isInitialized && ui.isInitialized;

    const hasException = !!categories.exception;
    const exception = categories.exception;

    useEffect(() => {
        if (isInitialized) {
            setIsLoading(false);
        } else {
            dispatch(initAuth());
            dispatch(initCart());
            dispatch(initUi());
        }
    }, [isInitialized, dispatch]);

    return {
        isLoading,
        hasException,
        exception,
        data: {
            categories
        }
    };
};
